export const testimonialData = [
  {
    id: 1,
    name: 'John Smith',
    testimonial:
      'Great experience renting a car from this company. The car was clean and reliable, and the staff was very helpful.',
    city: 'Los Angeles',
  },
  {
    id: 2,
    name: 'Emily Johnson',
    testimonial:
      'I rented a car for a weekend trip, and it was a breeze. The car was in excellent condition, and the rates were reasonable.',
    city: 'New York City',
  },
  {
    id: 3,
    name: 'David Brown',
    testimonial:
      'Outstanding service! The car was delivered to my doorstep, and the process was quick and efficient.',
    city: 'Chicago',
  },
  {
    id: 4,
    name: 'Sophia Lee',
    testimonial:
      "I've been a loyal customer for years, and this company never disappoints. Friendly staff and a wide range of cars to choose from.",
    city: 'San Francisco',
  },
  {
    id: 5,
    name: 'Michael Davis',
    testimonial:
      'I needed a car on short notice, and they came through for me. The car was clean, and the drop-off was convenient.',
    city: 'Miami',
  },
  {
    id: 6,
    name: 'Olivia Wilson',
    testimonial:
      'The car rental process was smooth, and the rates were competitive. Will definitely rent from them again.',
    city: 'Dallas',
  },
  {
    id: 7,
    name: 'William Jones',
    testimonial:
      'I rented a luxury car for a special occasion, and it made the day even more memorable. Thank you!',
    city: 'Las Vegas',
  },
  {
    id: 8,
    name: 'Emma Taylor',
    testimonial:
      'Excellent customer service and a wide variety of car options. Highly recommended!',
    city: 'Boston',
  },
  {
    id: 9,
    name: 'Liam Anderson',
    testimonial:
      'The car was in pristine condition, and the pickup and drop-off were hassle-free. A great rental experience.',
    city: 'Seattle',
  },
  {
    id: 10,
    name: 'Ava Martinez',
    testimonial:
      'I travel frequently, and this company is my go-to for car rentals. Consistently top-notch service.',
    city: 'Houston',
  },
];
